export const ADD_LOADING = "ADD_LOADING";
export const MONITORING_SUCCESS = "MONITORING_SUCCESS";
export const MONITORING_ERROR = "MONITORING_ERROR";
